import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#040A12] border-t border-[#C6A75E]/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 py-16">

        {/* Top row */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-16">

          {/* Brand */}
          <div className="max-w-xs">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://customer-assets.emergentagent.com/job_ksg-capital-partners/artifacts/4oti298i_KSG%20GROUP.jpg"
                alt="KSG Realty"
                className="w-9 h-9 object-cover rounded-sm opacity-80"
              />
              <div>
                <span className="font-serif text-white text-sm font-light tracking-[0.15em] uppercase">KSG Realty</span>
                <span className="font-sans text-[#C6A75E]/50 text-[10px] uppercase tracking-[0.2em] block"></span>
              </div>
            </div>
            <p className="font-sans text-xs text-slate-500 leading-relaxed font-light">
              Where capital meets real estate at scale. Strategic advisory for developers, family offices, and institutional investors.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="font-sans text-[10px] uppercase tracking-[0.2em] text-[#C6A75E]/70 mb-5">Navigate</p>
            <nav className="flex flex-col gap-3">
              {[["Home", "/"], ["About", "/about"], ["Services", "/services"], ["Contact", "/contact"]].map(([label, path]) =>
              <Link
                key={path}
                to={path}
                className="font-sans text-xs text-slate-500 hover:text-[#C6A75E] transition-colors duration-400 tracking-wide">

                  {label}
                </Link>
              )}
            </nav>
          </div>

          {/* Contact */}
          <div data-testid="footer-contact">
            <p className="font-sans text-[10px] uppercase tracking-[0.2em] text-[#C6A75E]/70 mb-5">Head Office</p>
            <p className="font-sans text-xs text-slate-500 leading-relaxed mb-4">
              1st Floor, 4 Ho Chi Minh Sarani<br />
              Kolkata — 700071
            </p>
            <p className="font-sans text-[10px] text-slate-600 tracking-wide mb-4">
              Associates &amp; offices in Mumbai · Bangalore
            </p>
            <a href="mailto:piyush@ksggrp.com" className="font-sans text-xs text-slate-500 hover:text-[#C6A75E] transition-colors duration-400 block mb-1">info@ksggrp.com

            </a>
            <a href="tel:+918583013161" className="font-sans text-xs text-slate-500 hover:text-[#C6A75E] transition-colors duration-400 block">
              +91 85830 13161
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#C6A75E]/20 to-transparent mb-8" />

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="font-sans text-[10px] text-slate-600 tracking-wide">
            &copy; {new Date().getFullYear()} All rights reserved.
          </p>
          <p className="font-sans text-[10px] text-slate-700 tracking-wider uppercase">
            Confidentiality · Precision · Scale
          </p>
        </div>
      </div>
    </footer>);

}